module.exports = __webpack_public_path__ + "media/images/baseline-circle-c2145708a25b44a302257524479c4c5f.svg";